import axios from 'axios';
import envBaseURL from './config/localhost.js';
import { defineStore } from 'pinia'
import User from './models/modelFiles/User.js';

const ax = axios.create({
  baseURL: envBaseURL,
  withCredentials: true,
  xsrfCookieName: "CSRF-TOKEN",
  xsrfHeaderName: "X-CSRF-Token",
});

let state = () => ({
  state_current_user: { id: undefined, roles: [] },
  routes: [],
  appLoaded: false,

})

let getters = {
  current_user(state) {
    // Point to state_Current_user, which is set along localStorage, this
    // ensures re-run, fetch of localStorage upon set user. Otherwise the getter
    // will return last value.
    // state.state_current_user;
    let usr = JSON.parse(localStorage.getItem('current_user')) || { id: undefined, roles: [] };
    // TODO: What is this? Should this be removed?
    // if (usr.id) {
    //   let res = state.users.find(us => us && us.id === usr.id);
    //   if (res) {
    //     return res;
    //   }
    // }
    return new User(usr);
  },
  current_user_is_employee(state) {
    const user = state.current_user;
    return user.roles?.includes("employee") || user.roles?.includes("aep");
  },
  current_user_is_investor(state) {
    const user = state.current_user;
    return user.roles.includes("client");
  },
  sign_in_path(state) {
    const user = state.current_user;
    if (user.roles.includes("family") && !user.roles.includes("employee") && !user.roles.includes("aep")) {
      return { path: "/employee/crm/reports" };
    } else if (user.roles.includes("norway") && !user.roles.includes("employee") && !user.roles.includes("aep")) {
      return { path: "/employee/markets/average_acquisition_costs" };
    }
    if (user.roles.includes("employee") || user.roles.includes("aep")) {
      return { path: "/employee/crm/clients" };
    } else if (user.roles.includes("client")) {
      return { path: "/investor/home" };
    } else {
      return { path: "/" };
    }
  }  
}

let actions = {
    SET_CURRENT_USER(payload) {
        this.state_current_user = payload;
        localStorage.setItem("current_user", JSON.stringify(payload));
    },
    async GET_ROUTES(){
        ax.get('/routes').then((res) => {
          this.routes = res.data
        })
    },
    SET_APP_LOADED(payload) {
        this.appLoaded = payload;
    },
    RESET_STATE() {
        // reset store state to initial values
        this.$reset();
        // clear user from localStorage as well
        localStorage.removeItem("current_user");
    }
}

export const useAuthenticationStore = defineStore('authentication', {
  state: state,
  getters: getters,
  actions: actions
});
